// src/pages/AboutPage.jsx
import React from "react";

export default function AboutPage() {
  return (
    <div className="space-y-10">
      <section className="rounded-3xl border border-white/10 bg-white/5 p-10">
        <p className="text-sm font-semibold text-cyan-300/90">Company</p>
        <h2 className="mt-3 text-3xl font-semibold tracking-tight text-white">About StarEpoch Labs</h2>
        <p className="mt-4 max-w-3xl mx-auto text-base leading-7 text-white/75">
          StarEpoch Labs is an independent software studio focused on privacy-first networking and security software.
          We aim to help people connect safely across networks while keeping data collection minimal and transparent.
        </p>

        <div className="mt-8 grid gap-6 md:grid-cols-3 mx-auto">
          <div className="rounded-2xl border border-white/10 bg-white/5 p-6">
            <div className="text-sm font-semibold text-white">Mission</div>
            <div className="mt-2 text-sm text-white/70">
              Build trusted networking software with clear privacy practices and reliable performance.
            </div>
          </div>
          <div className="rounded-2xl border border-white/10 bg-white/5 p-6">
            <div className="text-sm font-semibold text-white">Principles</div>
            <ul className="mt-2 space-y-2 text-sm text-white/70">
              <li>• Data minimization</li>
              <li>• Transparency by default</li>
              <li>• Security-first engineering</li>
              <li>• Reliability and user trust</li>
            </ul>
          </div>
          <div className="rounded-2xl border border-white/10 bg-white/5 p-6">
            <div className="text-sm font-semibold text-white">Legal</div>
            <div className="mt-2 text-sm text-white/70">StarEpoch Labs LLC</div>
            <div className="mt-1 text-sm text-white/70">Jurisdiction: United States</div>
            <div className="mt-1 text-sm text-white/70">Mailing address: 30 N Gould St Ste N, Sheridan, WY 82801</div>
          </div>
        </div>
      </section>
    </div>
  );
}
